module.exports = __webpack_public_path__ + "static/media/Illus-SummerEarly@3x.5b8db334.png";